/* Wholesale catalog filter/sort toolbar.
   Client-side faceting over the proxy-rendered offer cards, mirroring the
   B2B.Web catalog behavior (filters + sort, no server round-trip). Options are
   derived from each card's data-* attributes, so the toolbar adapts to
   whatever the current proxy deploy provides; with no cards or missing
   attributes it simply stays hidden/empty. */
(function () {
  'use strict';

  /* Image-switch arrows on the offer cards — a transform-based carousel (no scroll
     container, so it never captures the page's vertical scroll). Delegated so it
     works for every card the proxy renders. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-gb-prev],[data-gb-next]');
    if (!btn) return;
    e.preventDefault();
    var media = btn.closest('.gb-card__media');
    var track = media && media.querySelector('[data-gb-track]');
    if (!track) return;
    var count = track.children.length;
    var idx = parseInt(track.getAttribute('data-gb-index') || '0', 10);
    idx += btn.hasAttribute('data-gb-next') ? 1 : -1;
    idx = Math.max(0, Math.min(count - 1, idx));
    track.setAttribute('data-gb-index', idx);
    track.style.transform = 'translateX(-' + idx * 100 + '%)';
  });

  function init() {
    var toolbar = document.querySelector('[data-gb-toolbar]');
    var grid = document.querySelector('.gb-wholesale__grid');
    if (!toolbar || !grid) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-gb-card]'));
    if (cards.length === 0) return;

    toolbar.hidden = false;
    var countEl = document.querySelector('[data-gb-count]');
    var clearBtn = toolbar.querySelector('[data-gb-clear]');
    var sortSelect = toolbar.querySelector('[data-gb-sort]');
    var filterSelects = Array.prototype.slice.call(toolbar.querySelectorAll('[data-gb-filter]'));
    var originalOrder = cards.slice();

    // Native selects stretch to their WIDEST option, leaving the caret detached from the
    // visible label (unlike Horizon's facet pills, which hug their text). Size each select
    // to its current selection so the caret sits beside the label, and re-fit on change.
    var measurer = document.createElement('span');
    measurer.style.cssText = 'position:absolute;visibility:hidden;white-space:pre;';
    toolbar.appendChild(measurer);
    function fitSelect(select) {
      var opt = select.options[select.selectedIndex];
      // Copy individual font props — the `font` shorthand computes to '' in Firefox.
      var cs = window.getComputedStyle(select);
      measurer.style.fontFamily = cs.fontFamily;
      measurer.style.fontSize = cs.fontSize;
      measurer.style.fontWeight = cs.fontWeight;
      measurer.style.letterSpacing = cs.letterSpacing;
      measurer.textContent = opt ? opt.text : '';
      // label width + room for the caret (covered by the select's inline padding)
      select.style.width = Math.ceil(measurer.getBoundingClientRect().width) + 22 + 'px';
    }
    var fitAll = function () {
      filterSelects.concat(sortSelect ? [sortSelect] : []).forEach(fitSelect);
    };
    fitAll();
    filterSelects.concat(sortSelect ? [sortSelect] : []).forEach(function (s) {
      s.addEventListener('change', function () { fitSelect(s); });
    });
    // Re-fit once web fonts finish loading — the first pass may have measured a fallback face.
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitAll);

    // Filtered-to-zero empty state (the proxy's .gb-wholesale__empty is only for a
    // genuinely empty catalog). Inserted after the grid, shown when a filter hides
    // every card so the shopper isn't left staring at a blank grid.
    var noResults = document.createElement('p');
    noResults.className = 'gb-wholesale__empty';
    noResults.hidden = true;
    noResults.textContent = 'No lots match these filters. Clear a filter to see more.';
    grid.insertAdjacentElement('afterend', noResults);

    // Multi-valued fields (variety) are comma-separated in the attribute.
    function valuesOf(card, key) {
      var raw = card.getAttribute('data-' + key) || '';
      if (key === 'variety') {
        return raw.split(',').map(function (v) { return v.trim(); }).filter(Boolean);
      }
      return raw ? [raw] : [];
    }

    // Populate each empty select with the distinct values found in the cards.
    filterSelects.forEach(function (select) {
      var key = select.getAttribute('data-gb-filter');
      if (select.options.length > 1) return; // static options (availability)
      var seen = [];
      cards.forEach(function (card) {
        valuesOf(card, key).forEach(function (v) {
          if (seen.indexOf(v) === -1) seen.push(v);
        });
      });
      seen.sort();
      if (seen.length < 2) {
        select.hidden = true;
        return;
      }
      seen.forEach(function (v) {
        var opt = document.createElement('option');
        opt.value = v;
        opt.textContent = v;
        select.appendChild(opt);
      });
    });

    function priceOf(card) {
      var m = (card.getAttribute('data-price') || '').replace(/[^0-9.]/g, '');
      return m ? parseFloat(m) : NaN;
    }

    function apply() {
      var active = filterSelects.filter(function (s) { return !s.hidden && s.value !== ''; });
      var shown = 0;
      cards.forEach(function (card) {
        var visible = active.every(function (select) {
          var key = select.getAttribute('data-gb-filter');
          return valuesOf(card, key).indexOf(select.value) !== -1;
        });
        card.hidden = !visible;
        if (visible) shown++;
      });

      var order = originalOrder.slice();
      var sort = sortSelect ? sortSelect.value : '';
      if (sort) {
        var parts = sort.split('-');
        var key = parts[0];
        var dir = parts[1] === 'asc' ? 1 : -1;
        order.sort(function (a, b) {
          var av = key === 'price' ? priceOf(a) : parseFloat(a.getAttribute('data-score') || '');
          var bv = key === 'price' ? priceOf(b) : parseFloat(b.getAttribute('data-score') || '');
          if (isNaN(av)) return 1;
          if (isNaN(bv)) return -1;
          return (av - bv) * dir;
        });
      }
      order.forEach(function (card) { grid.appendChild(card); });

      if (countEl) {
        countEl.hidden = false;
        countEl.textContent = shown + (shown === 1 ? ' lot' : ' lots');
      }
      noResults.hidden = shown > 0;
      if (clearBtn) clearBtn.hidden = active.length === 0 && !sort;
    }

    filterSelects.forEach(function (s) { s.addEventListener('change', apply); });
    if (sortSelect) sortSelect.addEventListener('change', apply);
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        filterSelects.forEach(function (s) { s.value = ''; });
        if (sortSelect) sortSelect.value = '';
        apply();
      });
    }

    initDensity(toolbar, grid);
    apply();
  }

  // Grid density switcher (comfortable | dense), mirroring Horizon's collection
  // view control. Toggles data-gb-density on the grid (CSS does the rest) and
  // remembers the choice for the session (sessionStorage, matching the stock grid toggle).
  function initDensity(toolbar, grid) {
    var controls = toolbar.querySelector('[data-gb-density-controls]');
    if (!controls) return;
    var btns = Array.prototype.slice.call(controls.querySelectorAll('[data-gb-density-btn]'));
    if (btns.length === 0) return;
    var KEY = 'gb-wholesale-density';

    function set(density, persist) {
      var d = density === 'dense' ? 'dense' : 'comfortable';
      grid.setAttribute('data-gb-density', d);
      btns.forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-gb-density-btn') === d ? 'true' : 'false');
      });
      if (persist) { try { sessionStorage.setItem(KEY, d); } catch (e) { /* private mode */ } }
    }

    btns.forEach(function (b) {
      b.addEventListener('click', function () { set(b.getAttribute('data-gb-density-btn'), true); });
    });

    var saved = null;
    try { saved = sessionStorage.getItem(KEY); } catch (e) { /* private mode */ }
    set(saved, false);
    controls.hidden = false;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
